export default __webpack_public_path__ + "static/media/git-branch.928d67b2.svg";